import localizationDefinitions from '~/i18n/localizationDefinitions';
import { countryCodes } from '~/i18n/enums/countryCodes';

export const defaultVideoLanguageAndCountry: string =
  localizationDefinitions.getLanguageAndCountryByCountryCode(countryCodes.GB) ?? '';

export const FRENCH_COUNTRY_CODE = countryCodes.FR;
